import { InformationCircleIcon } from '@heroicons/react/24/outline';
import {
    DRAFT_REQUEST_BLOCK_HINT,
    DRAFT_REQUEST_BLOCK_MESSAGE,
    OPEN_REQUEST_BLOCK_HINT,
    OPEN_REQUEST_BLOCK_MESSAGE,
} from '../vacationRequestPage.definitions';
import type { VacationRequest } from '../../../models/vacation.types';

export interface OpenRequestPanelProps {
    request: VacationRequest;
}

export function OpenRequestPanel({ request }: OpenRequestPanelProps) {
    // Em carência a solicitação bloqueia uma nova, mas ainda não foi recusável por ninguém: o texto
    // padrão ("se esta for recusada") apontaria para um caminho que não existe nesse estado.
    const isDraft = request.status === 'Draft';
    const message = isDraft ? DRAFT_REQUEST_BLOCK_MESSAGE : OPEN_REQUEST_BLOCK_MESSAGE;
    const hint = isDraft ? DRAFT_REQUEST_BLOCK_HINT : OPEN_REQUEST_BLOCK_HINT;

    return (
        <div className="space-y-4">
            <div className="flex gap-3 rounded-xl border border-amber-200 bg-amber-50 p-4">
                <InformationCircleIcon className="h-5 w-5 shrink-0 text-amber-600 mt-0.5" />
                <div>
                    <p className="text-sm font-medium text-amber-900 font-montserrat">{message}</p>
                    <p className="mt-1 text-xs text-amber-800 font-montserrat">{hint}</p>
                </div>
            </div>
        </div>
    );
}

export default OpenRequestPanel;
